import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const Incognito = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon {...other}>
			<path
				d="M13,12 C14.6568542,12 16,13.3431458 16,15 C16,16.6568542 14.6568542,18 13,18 C11.3431458,18 10,16.6568542 10,15 C10,14.8349375 10.0133307,14.6729884 10.0389741,14.5151709 C9.8316903,14.455876 9.62302001,14.4264934 9.4134846,14.4264934 C9.25500472,14.4264934 9.10209091,14.4433017 8.95474316,14.4769183 C8.98451962,14.6478668 9,14.8221256 9,15 C9,16.6568542 7.65685425,18 6,18 C4.34314575,18 3,16.6568542 3,15 C3,13.3431458 4.34314575,12 6,12 C6.98471708,12 7.85862374,12.4744358 8.40560674,13.2071942 C8.71516762,13.0685494 9.05167439,13 9.4134846,13 C9.79849335,13 10.1859521,13.0776218 10.5758607,13.2328653 C11.1205465,12.4858201 12.0035386,12 13,12 Z M6,13 C4.8954305,13 4,13.8954305 4,15 C4,16.1045695 4.8954305,17 6,17 C7.1045695,17 8,16.1045695 8,15 C8,13.8954305 7.1045695,13 6,13 Z M13,13 C11.8954305,13 11,13.8954305 11,15 C11,16.1045695 11.8954305,17 13,17 C14.1045695,17 15,16.1045695 15,15 C15,13.8954305 14.1045695,13 13,13 Z M12.9520676,3 L15,9 L12.1844312,9 L12.592,10 L15,10 L14.7696644,9.32206225 C17.3103608,9.69702783 19,10.3626657 19,11.1213203 C19,12.2928932 1,12.2928932 1,11.1213203 C1,10.3625655 2.69008586,9.69685187 5.2313431,9.32191359 L5,10 L11.208,10 L11,9 L5,9 L7.04793238,3 L9.5729607,4.00034062 L7.85714286,5.14933891 L8.06600163,5.57142857 L10,4.21659936 L9.96350041,4.15506076 L10,4.1695208 L12.9520676,3 Z"
				id="incognito"
				fill={color}
			/>
		</CustomSVGIcon>
	);
};

Incognito.propTypes = {
	color: PropTypes.string,
};

export default Incognito;
